export enum ACTUATION_KIND {
  CONSTITUTION = 1,
  MODIFICATION = 2,
  TRANSFORMATION = 3,
  DISSOLUTION = 4,
  MIGRATION = 5,
  RECTIFICATION = 6,
  SANITATION = 7,
  EMIGRATION = 8,
  ANNOTATION = 9,
  FUSION = 10,
  POWER_REVOCATION = 11,
  POWER_DESIGNATION = 12,
  CESSION_OF_RIGHTS = 13,
  POWERS = 14,
  OTHER = 100,
}

export const AVAILABLE_ACTUATION_KINDS = [
  ACTUATION_KIND.CONSTITUTION,
  ACTUATION_KIND.MODIFICATION,
  ACTUATION_KIND.TRANSFORMATION,
  ACTUATION_KIND.MIGRATION,
  ACTUATION_KIND.RECTIFICATION,
  ACTUATION_KIND.SANITATION,
  ACTUATION_KIND.OTHER,
];

export const STUDY_ACTUATION_KINDS = [
  {
    value: ACTUATION_KIND.CONSTITUTION,
    displayName: 'constitución',
  },
  {
    value: ACTUATION_KIND.MODIFICATION,
    displayName: 'modificación',
  },
  {
    value: ACTUATION_KIND.TRANSFORMATION,
    displayName: 'transformación',
  },
  {
    value: ACTUATION_KIND.DISSOLUTION,
    displayName: 'disolución',
  },
  {
    value: ACTUATION_KIND.MIGRATION,
    displayName: 'migración',
  },
  {
    value: ACTUATION_KIND.RECTIFICATION,
    displayName: 'rectificación',
  },
  {
    value: ACTUATION_KIND.SANITATION,
    displayName: 'saneamiento',
  },
  {
    value: ACTUATION_KIND.EMIGRATION,
    displayName: 'emigración',
  },
  {
    value: ACTUATION_KIND.ANNOTATION,
    displayName: 'anotación',
  },
  {
    value: ACTUATION_KIND.FUSION,
    displayName: 'fusión',
  },
  {
    value: ACTUATION_KIND.POWER_REVOCATION,
    displayName: 'revocación de poder',
  },
  {
    value: ACTUATION_KIND.POWER_DESIGNATION,
    displayName: 'designación de poder',
  },
  {
    value: ACTUATION_KIND.CESSION_OF_RIGHTS,
    displayName: 'cesión de derechos',
  },
  {
    value: ACTUATION_KIND.POWERS,
    displayName: 'poderes',
  },
  {
    value: ACTUATION_KIND.OTHER,
    displayName: 'otro',
  },
];

export const STUDY_ACTUATION_KINDS_AVAILABLE = STUDY_ACTUATION_KINDS.filter(
  (studyActuationKind) =>
    AVAILABLE_ACTUATION_KINDS.includes(studyActuationKind.value),
);
